<!--
    高级编辑器-左侧菜单部分
    作用：提供场景管理与课件管理；
    实现：展现数据；
    组件：
        import Blocks from './components/blocks'
        import Lesson from './components/lesson'//课程模块
        import BtnsBox from './components/btnsBox'
    注释：WJ
-->
<template>
    <div class="menus-box"
        :class="{
            'deep-black': true,
            'show': isShow,
            'middle': drapValue >30,
            'large': drapValue>57
        }"
        :style="!curIsCourse && isShow && drapValue>0?`width:${drapValue + 230}px`:null"
        @click="handleMouseEnterOpen"
    >
        <div
            v-if="($store.state.saving || $store.state.isBuildCocos || $store.state.isCocosSaving)"
            class="disabled"></div>
        <BtnsBox
            v-if="mulSelect"
            :form="btnsData"
            @onSelect="btnsBoxOnSelect"
        />
        <div v-if="$store.state.isPPTUploadRate"
             class="ppt-loading"
             @click="$message.warning('PPT正在导入中，请稍等')"
        ></div>
        <div class="txt-box"
            :class="{
                'full': selectedMenuType === 'course'
            }"
        >
            <div class="type-box">
                <p class="btn"
                   :class="{active: !curIsCourse}"
                   @click="selectedMenuType = 'scene'"
                >场景</p>
                <p class="btn"
                   :class="{active: curIsCourse}"
                   @click="selectedMenuType = 'course'"
                >课件</p>
            </div>
            <div
                v-if="curIsCourse"
                class="nav-names"
            >
                <p class="name">
                    <el-tooltip
                            class="item"
                            effect="light"
                            :content="curNavs"
                            placement="right"
                            :open-delay="$enums.openDelay.nomal"
                    >
                        <span>{{curNavs}}</span>
                    </el-tooltip>
                </p>
            </div>
            <div class="menu-content">
                <Blocks
                    ref="blocks"
                    :class="{
                        isHide: curIsCourse
                    }"
                    :menuShow="isShow"
                    :curIsCourse="curIsCourse"
                    :newDrapValue.sync="drapValue"
                    :selected.sync="$store.state.menusData.blocksSelected"
                    :mouseEnterNav.sync="newMouseEnterNav"
                    :mouseEnterNavItem.sync="newMouseEnterNavItem"
                    @onBlocks="onBlocks"
                    @onAddBlocks="onAddBlocks"
                    @onAdd="onAdd"
                    @onEdit="onEdit"
                    @onDelete="onDelete"
                    @rightClick="$emit('rightClick', $event)"
                />
                <Lesson
                    v-if="isLesson"
                    ref="lesson"
                    :isFull="curIsCourse"
                    :is-add="lessonIsAdd"
                    :parentId.sync="parentId"
                    :isRemark="isRemark"
                    :selected.sync="$store.state.menusData.lessonSelected"
                    :mouseEnterItem.sync="newMouseEnterItem"
                    :mouseEnterLessonList.sync="newMouseEnterLessonList"
                    @edit="edit"
                    @del="del"
                    @move="move"
                    @copy="copy"
                    @add="add"
                    @addPPT="addPPT"
                    @more="more"
                    @onSelect="onSelect"
                    @onRemark="onRemark"
                    @flashContent="$emit('flashContent')"
                />
            </div>
        </div>
        <!--<div class="more-boxshadow" :class="{'hide': !isShow}"></div>-->
        <!--<div class="more-boxshadow2" :class="{'hide': !isShow}"></div>-->
        <div class="sousuo" :class="{'hide': !isShow}">
            <span @click="handleIsShow" class="iconfont">
                <span class="more">
                <span class="icon-jiantouxiangyou"></span>
                </span>
            </span>
            <!--<img @click="handleIsShow" crossOrigin="anonymous" class="img" :src="$images.menus.zuogengduo" alt="" />-->
        </div>
        <div
            v-if="is_global_select_menu"
            class="menu-btns">
            <el-button
                class="btn"
                size="small"
                @click="cancelPPT"
            >取消</el-button>
            <el-button
                class="btn submit"
                size="small"
                @click="submitSelectMenu"
            >确认</el-button>
        </div>
    </div>
</template>

<script>
    import Blocks from './components/blocks'
    import Lesson from './components/lesson'
    import BtnsBox from './components/btnsBox'
    import {getRandomByObj} from "../../../../utils/utils";
    import {clickFile} from "../../../../utils/upload";
    import LocalStorage from '../../../../utils/localStorageUtil'
    import {mapState, mapActions} from 'vuex'
    import * as GlobalServer from '../../../../api/global'
    import * as ResultServer from '../../../../api/result'

    export default {
        name: "menus",
        components: {
            Blocks,
            Lesson,
            BtnsBox
        },
        props: {
            show: {
              type: Boolean,
              default: true
            },
            lessonIsAdd: {
              type: Boolean,
              default: false
            },
            mouseEnterItem: Object,
            mouseEnterNav: Object,
            mouseEnterNavItem: Object,
            isOptToBlock:{
                type: Boolean,
                default: false
            },
            isOptType: String,
            optToBlockItem: [Object, Array],
            menusData: [Object, Array],
            isRemark: {
                type: Boolean,
                default: false
            },
            isPractice: {
                type: Boolean,
                default: false
            },
            curForms: Array
        },
        computed:{
            ...mapState([
                'is_global_select_menu',
                'global_select_unique',
                'isCocosSaving',
                'editGameConfig',
                'menusDataIds',
                'mulSelect'
            ]),
            curScene(){
                return this.$store.state.menusData.blocksForm[this.$store.state.menusData.blocksSelected].name
            },
            curThemeUrl(){
                return this.$store.state.menusData.blocksForm[this.$store.state.menusData.blocksSelected].theme
            },
            // 当前是课件类型
            curIsCourse(){
                return this.selectedMenuType === 'course'
            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.init()

                // 判断本地存储是否存在引导页完成
                if(LocalStorage.getGuideStep() === 'done'){
                    this.$store.state.guideStep = 'done'
                } else{
                    this.$store.state.guideStep = 'start'
                }
            })
        },
        watch: {
            show(vl){this.isShow = vl},
            isShow(vl){this.$emit('update:show',vl)},
            isOptType(vl){this.newIsOptType = vl},
            newIsOptType(vl){this.$emit('update:isOptType',vl)},
            mouseEnterItem(vl){this.newMouseEnterItem = vl},
            newMouseEnterItem(vl){this.$emit('update:mouseEnterItem',vl)},
            mouseEnterLessonList(vl){this.newMouseEnterLessonList = vl},
            newMouseEnterLessonList(vl){this.$emit('update:mouseEnterLessonList',vl)},
            mouseEnterNav(vl){this.newMouseEnterNav = vl},
            newMouseEnterNav(vl){this.$emit('update:mouseEnterNav',vl)},
            mouseEnterNavItem(vl){this.newMouseEnterNavItem = vl},
            newMouseEnterNavItem(vl){this.$emit('update:mouseEnterNavItem',vl)},
            isOptToBlock(vl){this.newIsOptToBlock = vl},
            newIsOptToBlock(vl){this.$emit('update:isOptToBlock',vl)},
            optToBlockItem(vl){this.newOptToBlockItem = vl},
            newOptToBlockItem(vl){this.$emit('update:optToBlockItem',vl)},
            menusData:{
                handler(vl) {
                    console.log("vlvlvlvlvlvlvl",vl);
                    this.$store.state.menusData = vl
                },
                deep: true,
                // immediate: true
            },
            curForms(vl){
                this.lessonForm = vl
            },
            lessonForm:{
                handler(vl){
                    if(this.isCocosSaving) return false
                    //console.warn('优化速度==>lessonForm')
                    if(vl && vl.length>0) {
                        this.$emit('update:curForms', vl)
                        try {
                            // this.isLesson = false
                            // 1.记住当前菜单滚动条位置
                            let position = this.$refs.lesson.getScrollPosition()
                            //console.log('滚动当前位置==>', position)

                            let fn = setTimeout(() => {
                                // this.isLesson = true
                                // 2.恢复滚动条滚动位置
                                this.$nextTick(() => {
                                    //console.log("2.恢复滚动条滚动位置")
                                    this.$refs.lesson && this.$refs.lesson.setScrollPosition && this.$refs.lesson.setScrollPosition({position})
                                })
                                clearTimeout(fn)
                            }, 200)
                            // this.changeMenusData(vl)
                        }catch (e) {
                            console.log('获取当前滚动条错误==>', e)
                        }
                    }
                },
                deep: true,
                immediate: false
            }
        },
        data(){
            return {
                curNavs: '', // 当前导航面包屑
                isPPTing: [], // ppt当前正在导入的ppt列表
                isLesson: true,
                newMouseEnterItem: this.mouseEnterItem, // 鼠标移到的数据元素
                newMouseEnterLessonList: this.mouseEnterLessonList, // 鼠标移到的数据元素
                newMouseEnterNav: this.mouseEnterNav, // 鼠标移到导航上
                newMouseEnterNavItem: this.mouseEnterNavItem, // 鼠标移到导航上的元素
                isShow: this.show,
                newMenusData: this.menusData,
                parentId: -1, // 板块id
                lessonForm: [],

                // 移动或复制
                newIsOptType: this.isOptType, // 操作类型
                newIsOptToBlock: this.isOptToBlock,
                newOptToBlockItem: this.optToBlockItem,
                pptFn: null,

                selectedMenuType: 'scene', // scene 场景 ｜ course 课件

                drapValue: 0, // 菜单拖动距离
                // 按钮组
                btnsData: [
                    {key: 'copy', value: '复制：<font style=color:#aaaaaa>Ctrl+c</font>'},
                    {key: 'move', value: '剪切：<font style=color:#aaaaaa>Ctrl+x</font>'},
                    {key: 'cancel', value: '取消：<font style=color:#aaaaaa>Ctrl+z</font>'},
                    {key: 'setTemplate', value: '转换为模版'}
                ]
            }
        },
        methods: {
            ...mapActions(['cancelSelectMenu','setSendKeyBoardToCocos']),
            init(){
                try {
                    this.$nextTick(()=>{
                        // this.isLesson = false
                        this.parentId = 0
                        // const data = this.$store.state.menusData.blocksForm
                        // const unique = this.$store.state.menusData.blocksSelected

                        // 判断当前选中的是目录还是最后一片叶子
                        // 如果是目录，直接展开
                        // 否则展示课件页数据
                        const node = this.menusDataIds[this.$store.state.menusData.blocksSelected] //this.$utils.curSelectedNode({data})
                        // console.log('优化速度==>menus初始化', node, unique)
                        this.lessonForm = node && node.children || []
                        // this.$refs.blocks.setCurrentKey &&
                        // this.$refs.blocks.setCurrentKey()
                    })
                    // setTimeout(()=>{
                    //     this.isLesson = true
                    // }, 5000)
                }catch (e) {
                    console.log('等待获取菜单==>', e)
                }
            },
            // 按钮选中
            btnsBoxOnSelect(item){
                const {key} = item
                const isHas = ()=>{
                    let len = this.mulSelect.length
                    if(len<=0){
                        this.$message.warning('当前选中为空')
                    }
                    return len
                }
                switch (key) {
                    case 'cancel':
                        this.$store.state.mulSelect = null
                        break
                    case 'move':
                        if(isHas()){
                            this.moveLesson();
                            //this.move() //原方法
                        }
                        break
                    case 'copy':
                        if(isHas()){
                            this.copyLesson();
                            //this.copy() //原方法
                        }
                        break
                    case 'setTemplate':
                        if(isHas()){
                           // 1.弹出输入模版名称
                           // 2.新增模版
                            this.newIsOptType = 'setTemplate'
                            this.newIsOptToBlock = true
                        }
                        break
                }
            },
            handleNodeClick({data}){
                this.$refs.blocks &&
                this.$refs.blocks.handleNodeClick &&
                this.$refs.blocks.handleNodeClick(data)
            },
            // 更新当前PPT状态
            async updateCurPPTStatus({resources_id, status, callBack}){
                const opted = await ResultServer.updatePPTStatus({
                    clientsId: this.$store.state.initConfig.school_id,
                    resources_id,
                    status
                })
                callBack && callBack(opted)
            },
            // 取消PPT
            cancelPPT(){
                // 1.向服务端通知取消导入PPT
                // 2.关闭弹窗
                // 3.更新ppt历史记录列表
                console.log('取消PPT==>')
                this.cancelSelectMenu((opted)=>{
                    if(opted && opted.status_code === 200) {
                        this.$emit('flashPPTList')
                        this.$message.success('取消成功')
                    } else {
                        this.$message.error('取消失败')
                    }
                })
            },
            // 确定
            submitSelectMenu(){
                // 1.判断菜单目录是否有值
                // 2.确定当前选中的菜单目录内 菜单选中是否有值
                // 3.通知服务端当插入ppt
                // 4.服务端通知完真正插入ppt
                // 5.清空菜单选中
                // 6.刷新ppt历史记录
                // 7.关闭当前选择菜单
                const finalFunction = ()=>{
                    this.$emit('flashPPTList')
                    this.$store.state.is_global_select_menu = false
                }
                const realInsertPPT2Menu = (index = 0)=>{
                    this.updateCurPPTStatus({
                        resources_id: this.$store.state.tempInsertPPTConfig.data.id,
                        status: 2,
                        callBack: (opted)=>{
                            if(opted && opted.status_code === 200) {

                                // 获取ppt转码后的字段
                                // [{type:"html",config:{url:"xxx/Slide1.html"}}]
                                this.insertPPT2Menu({
                                    h5_remote:this.$store.state.tempInsertPPTConfig.data.attributes.h5_dir,
                                    limit:this.$store.state.tempInsertPPTConfig.data.attributes.limit,
                                    index,
                                    cocos_dir:this.$store.state.tempInsertPPTConfig.data.attributes.cocos_dir,
                                    static_id:this.$store.state.tempInsertPPTConfig.data.attributes.id,
                                    flash: true
                                })
                                finalFunction()
                            }
                        }
                    })
                }
                if(this.menusData.blocksSelected){
                    console.log('通知服务端插入ppt==>')
                    if(!this.$store.state.global_select_unique){
                        // 将PPT插入到当前菜单目录下
                        realInsertPPT2Menu()
                    } else {
                        // 获取当前目录节点
                        // 判断当前菜单目录下，【global_select_unique】标识的索引，
                        // 存在则将PPT插入到该菜单下 否则直接将PPT插入到该菜单目录下
                        let index = 0
                        let catalogNode =  this.$utils.curSelectedNode({unique: this.menusData.blocksSelected})
                        if(catalogNode && catalogNode.children.length){
                            catalogNode.children.map((v,i)=>{
                                if(`${v.unique}` === `${this.$store.state.global_select_unique}`) {
                                    index = i
                                }
                            })
                        }
                        realInsertPPT2Menu(index)
                    }
                }else{
                    this.$message.error('请先选择您要插入的菜单位置')
                }

            },
            flushLeeson(state){
                this.$refs.lesson.flashLesson(state)
            },
            flashLesson(state){
                try {
                    if(!state) this.isLesson = false
                    // 1.记住当前菜单滚动条位置
                    let position = this.$refs.lesson.getScrollPosition()
                    console.log('滚动当前位置==>', position)

                    let fn = setTimeout(() => {
                        if (!state) {
                            this.isLesson = true
                            // 2.恢复滚动条滚动位置
                            this.$nextTick(() => {
                                this.$refs.lesson && this.$refs.lesson.setScrollPosition && this.$refs.lesson.setScrollPosition({position})
                            })
                        }
                        clearTimeout(fn)
                    })
                    // this.changeMenusData(vl)
                }catch (e) {
                    console.log('获取当前滚动条错误==>', e)
                }
            },
            setLessonForm({data}){
                this.lessonForm = this.$_.cloneDeepWith(data)
                $eventBus.$emit('onFlashLesson', true, null)
            },
            // 添加导航
            onAdd({fn, addPage}){
                this.$emit('onAdd', {fn, addPage})
            },
            // 编辑导航
            onEdit(item){
                this.$emit('onEdit', item)
            },
            // 删除导航
            onDelete(item){
                this.$emit('onDelete', item)
            },
            // 课件变更整体数据同步
            changeMenusData(data){
                this.$store.state.menusData.blocksForm[this.menusData.blocksSelected].children = data
            },
            // 获取当前滚动条滚动位置
            getLessonScrollPosition(){
                return this.$refs.lesson.getScrollPosition()
            },
            // 设置滚动条位置
            setLessonScrollPosition({position}){
                this.$refs.lesson && this.$refs.lesson.setScrollPosition && this.$refs.lesson.setScrollPosition({position})
            },
            addLesson(){
                let index=0;
                const node = JSON.parse(JSON.stringify(this.menusDataIds[this.menusData.blocksSelected]))
                let thisunique=this.$store.state.menusData.lessonSelected;
                node.children.map((v, i)=>{
                    if(`${v.unique}` === `${thisunique}`)index = i
                })
                this.$refs.lesson.opt('add', index, 'flash');
            },
            // 删除课程
            deleteLesson(data, parentIndex){
                this.$refs.lesson.deleteLesson(data, parentIndex)
            },
            // 移动课程
            moveLesson(data){
                this.$refs.lesson.moveLesson(data)
            },
            // 复制课程
            copyLesson(data){
                this.$refs.lesson.copyLesson(data)
            },
            // 粘贴课程
            pasteLesson(){
                this.$refs.lesson.pasteLesson()
            },
            handleIsShow(){
                this.isShow = !this.isShow
            },
            // 获取当前选中的游戏类型
            getCurType(){
                let name = ''
                try {
                    console.log('优化速度==>getCurType')
                    const node = this.menusDataIds[this.menusData.lessonSelected] || {} //this.$utils.getObjByCurLesson({})
                    name = node.type
                }catch (e) {
                    console.log('获取当前选中游戏类型失败==>', e)
                }
                return name
            },
            // 板块
            onBlocks(newItem){
                // this.$emit('onCurForm', [])
                //console.log('onBlocks==>', this.$_.cloneDeepWith(newItem))
                const item = this.menusDataIds[newItem.unique]
                // this.lessonForm = item && item.children || []
                this.$store.state.menusData.blocksSelected = item.unique
                console.log("板块板块板块板块板块板块",this.$store.state.menusData.blocksSelected);
                this.$store.state.menusData.willGo = item.children && item.children.length>0?item.children[0].unique : ''
                this.$store.state.menusData.willGoConfig = {type:item.children && item.children.length>0?item.children[0].type : ''}

                // 向服务器通知 选中当前菜单
                const operation = [{node: 'root', key: 'blocksSelected', data: item.unique, operation: 'value'}]
                $eventBus.$emit('__save__',true,null, operation)
                //console.log('操作==>选中菜单', operation, item)

                const nextGo = ()=>{
                    console.log('retro lessonSelected6')
                    this.$store.state.menusData.lessonSelected = this.$store.state.menusData.willGo
                    this.$store.state.menusData.lessonSelectedConfig = this.$store.state.menusData.willGoConfig
                    if(!this.$store.state.menusData.lessonSelected) return false


                    // let node = this.$utils.curSelectedNode({
                    //     unique: this.$store.state.menusData.willGo
                    // })
                    let node = this.$store.state.menusDataIds[item.unique]
                    let obj = {}
                    if(node.children && node.children[0]) obj = node.children[0]

                    let value = getRandomByObj(obj)
                    console.log('retro lessonSelected7')
                    this.$store.state.menusData.lessonSelected = value.unique
                    console.log('优化速度nextGo==>GetLessonConfig')
                    this.$toCocosMessage({type:'GetLessonConfig', value: getRandomByObj(value)})
                }

                // 如果当前是游戏情况下，且什么都没变，则直接切菜单及课件
                //console.log('优化速度==>onBlocks')
                // 优化 如果是从游戏开始切课件 判断当前是否为未保存
                if(this.editGameConfig &&
                    this.editGameConfig.configStatus &&
                    this.editGameConfig.configStatus.saved){
                    this.$store.state.isCocosSaving = false
                    nextGo()
                    return false
                }

                // 如果当前菜单有页面，则先保存，否则直接跳转
                if (item) {
                    //const form = this.menusDataIds[this.$store.state.menusData.blocksSelected]
                    //console.log('优化速度==>选中板块', item, this.$_.cloneDeepWith(form))
                    // this.$emit('onCurForm', form && form.children)
                    this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'changeMenu'}})
                } else {
                    // 上一个动作 在什么都没有的情况下或者什么都不变 直接给cocos配置
                    console.log('111==>')
                    nextGo()
                }
                // $eventBus.$emit('onFlashLesson')
            },
            onAddBlocks(){
                console.log('添加板块==>')
                this.blocksForm.push({id: Math.random(), url: this.$images.menus.bankuai,name: '板块'+(this.blocksForm.length +1)})
            },
            // 删除
            del(item){
                this.setSendKeyBoardToCocos({key: 'isDeleteLesson', value: false})
                this.$confirm('此操作将删除该课程, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    // 1.通过课程唯一值 unique 找到该课程的目录，及当前课程索引
                    // 2.删除课程
                    // 3.刷新菜单数据
                    // 4.返回当前删除的上一个 unique 否则返回下一个，如果都没有的话返回空串

                    // 删除课件映射
                    console.log('删除课件==>1', item,this.$store.state.menusData)
                    const nodeBlock = this.menusDataIds[this.$store.state.menusData.blocksSelected]
                    console.log('删除课件==>2', nodeBlock)

                    console.log('优化速度==>del1', this.$store.state.menusData.blocksForm)
                    let deleteNode = this.$utils.getObjByCurLesson({
                        data: this.$store.state.menusData.blocksForm,
                        unique: item.unique,
                        type: 'delete',
                        ids: this.menusDataIds
                    })
                    console.log('deleteNode2==>', deleteNode)

                    let index = -1
                    nodeBlock.children.map((v,i)=>{
                        if(`${v.unique}` === `${item.unique}`){
                            index = i
                        }
                    })
                    if(index>-1){nodeBlock.children.splice(index, 1)}

                    // debugger
                    if(deleteNode.unique) {
                        console.log('retro lessonSelected8')
                        this.$store.state.menusData.lessonSelected = deleteNode.unique
                        this.$store.state.menusData.lessonSelectedConfig = {type: deleteNode.uniqueNode.type}
                    } else {
                        console.log('retro lessonSelected9')
                        this.$store.state.menusData.lessonSelected = ''
                        this.$store.state.menusData.lessonSelectedConfig = {}
                    }

                    $eventBus.$emit('onCurForm', this.menusDataIds[deleteNode.parentNode.unique] || [])

                    // TODO 删除课件
                    const operation = [{node: 'children', toUnique: item.unique, operation: 'delete'}]
                    $eventBus.$emit('__save__',true,null, operation)
                    console.log('操作==>删除课件', operation, `删除${this.$store.state.menusData.lessonSelected}lll`)

                    // console.log('删除课程==>', item, parentIndex, this.menusData.blocksForm, item.index)
                    // this.menusData.blocksForm[parentIndex].children.splice(item.index, 1)
                    // // 每删除一个,当前选中的为上一个，如果当前删除的就是第一个了,则第二个默认选中
                    // const curIndex = item.index > 0 ? (item.index - 1) : 0
                    // this.menusData.lessonSelected = `${this.menusData.blocksSelected}/${curIndex}`
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    // 删除成功先保存一次
                    this.$emit('save', true)

                    console.log('优化速度==>del2',this.$store.state.menusData)
                    let curLessonNode = this.menusDataIds[deleteNode.unique]

                    // 通知cocos删除课件
                    if(curLessonNode){
                        console.log('优化速度curLessonNode==>GetLessonConfig')
                        console.log('retro=>向cocos发配置5')
                        this.$store.dispatch('setIsBuilding', true)
                        this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(curLessonNode)})
                    } else {
                       this.$emit('flashContent')
                    }
                    this.$refs.lesson.flashLesson()
                }).catch((e) => {
                    console.log('删除失败2==>', e)
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                }).finally(()=>{
                    this.setSendKeyBoardToCocos({key: 'isDeleteLesson', value: true})
                })
                console.log('删除==>', item)
            },
            // 移动
            move(item){
                this.newIsOptType = 'move'
                this.newIsOptToBlock = true
                this.newOptToBlockItem = item
                console.log('移动==>', item)
            },
            // 复制
            copy(item){
                this.newIsOptType = 'copy'
                this.newIsOptToBlock = true
                this.newOptToBlockItem = item
                console.log('复制==>', item)
            },
            // 课程
            edit(item){
                console.log('编辑==>', item)
            },
            add(index, flash){
                console.log('flash==>', index, flash)
                this.$store.state.editGameConfig = null
                if(flash){
                    this.realAdd({index, flash})
                    this.$refs.lesson.flashLesson()
                    return false
                }
                // 添加之前先保存
                this.$toCocosMessage({type: 'SaveConfig', value: {flag: {type:'add', index, flash}}})
            },
            addPPT(index, flash, item){
                if(this.isPPTing.length>0){
                    this.$message.error('ppt正在导入中')
                    return false
                }
                if(this.$store.state.isPPTUploadRate){
                    this.$message.error('当前有ppt正在处理中')
                    return false
                }
                const self = this
                // 初始化状态弹窗
                this.$emit('flushStatus')

                // this.isPPTing = true
                // options 表示当前ppt是否要导入对应的菜单或目录下
                let options = null
                if(item && item.unique){
                    options = JSON.stringify({type: 'leaf', unique: item.unique})
                } else if(index === 0 && flash === 'flash' && this.$store.state.menusData.blocksSelected){
                    options = JSON.stringify({type: 'catalog', unique: this.$store.state.menusData.blocksSelected})
                }

                // source 1 我的课件 2 我的模板 3 公共模板
                let source = '1'
                if(`${this.$route.query.is_practice}` === 'true'){
                    source = '4'
                } else if (`${this.$route.query.is_template}` === 'true'){
                    source = '2'
                    if(`${this.$route.query.is_shop}` === 'true') source = '3'
                }

                // 1.导入ppt
                // 2.导入成功后回调 将ppt插入到索引位置
                if(this.$utils.isFastExecute(200)){
                    return false
                }

                clickFile({
                    isPlat:this.$store.getters.isPlat,
                    accept: '.pptx',
                    backType: 'object',
                    callback: async (res) => {
                        console.log('上传ppt回调==>', res)
                        this.$store.state.isPPTUploadRate = true
                        this.$store.state.isPPTUploading = true
                        this.$store.state.curPPTRate = 0
                        // 1.PPT导入成功后 拿到后端返回的ppt压缩路径和页数 开始插入菜单
                        // 2.实时请求后端状态接口
                        const result_id = source === '4'? this.$route.query.practice_id : parseInt(this.$route.query.id)
                        const result = await GlobalServer.importPPT({
                            clientsId: this.$store.state.initConfig.school_id,
                            name: res.name,
                            url: res.url.split('.com/')[1],
                            etag: this.$utils.getMd5(res.url),
                            result_id,
                            source,
                            options
                        })
                        if(result && result.status_code === 200){
                            console.log('retro1==>', 1)
                            this.isPPTing.push(res.url)
                            const unique = this.$store.state.menusData.blocksSelected
                            // 轮询ppt解码状态
                            const func = async ()=> {
                                    console.log('retro1==>', 2)
                                    const status = await GlobalServer.getPPTStatus({
                                        id: result.data.id,
                                        result_id,
                                        source
                                    })
                                    // 更新ppt列表
                                    this.$emit('flashPPTList', 'only')
                                    if (`${status.data.attributes.status}` === '3') {
                                        this.$store.state.isPPTUploadRate = false
                                        let indexUrl = this.isPPTing.indexOf(res.url)
                                        if (indexUrl > -1) this.isPPTing.splice(indexUrl, 1)
                                        this.$message.error('PPT转换失败')
                                        clearTimeout(self.pptFn)
                                        return
                                    }
                                    const progress = status.data.attributes.progress
                                    this.$store.state.curPPTRate = progress

                                    if (progress >= 100) {
                                        console.log('retro1==>', 3)
                                        this.$message.success('PPT导入成功')
                                        if (this.$store.state.isPPTUploadRate) this.$store.state.isPPTUploadRate = false
                                        console.log('6969==>0', status.data.attributes.cocos_dir)
                                        // 解码成功
                                        // 关闭当前ppt百分比弹窗
                                        // 前端手动设置ppt状态 设置为已插入页面中
                                        // 将ppt内容约定的格式，重新组件插入到菜单中
                                        this.realUpdateAndInsertPPT({
                                            resources_id: status.data.id,
                                            status: 2,
                                            cocos_dir: status.data.attributes.cocos_dir,
                                            static_id: status.data.attributes.id,
                                            h5_remote: status.data.attributes.h5_dir,
                                            limit: status.data.attributes.limit,
                                            index,
                                            flash,
                                            unique
                                        })

                                        let indexRecord = this.isPPTing.indexOf(res.url)
                                        if (indexRecord > -1) this.isPPTing.splice(indexRecord, 1)
                                    }else{
                                        clearTimeout(self.pptFn)
                                        self.pptFn = setTimeout(()=>{
                                            func()
                                        }, 2000)
                                    }
                            }
                            func && func()
                        }
                    }
                })

                console.log('flash-ppt==>', index, flash)
                if(flash){
                    // this.realAdd({index, flash})
                    return false
                }
                // 添加之前先保存
                // this.$toCocosMessage({type: 'SaveConfig', value: {flag: {type:'add', index, flash}}})
            },
            // 真正更新ppt状态并插入到菜单中
            realUpdateAndInsertPPT({resources_id, status, cocos_dir, static_id, h5_remote, limit, index, flash, unique}){
                this.updateCurPPTStatus({
                    resources_id,
                    status,
                    callBack: (opted)=>{
                        if(opted && opted.status_code === 200) {

                            // 获取ppt转码后的字段
                            // [{type:"html",config:{url:"xxx/Slide1.html"}}]
                            this.insertPPT2Menu({
                                cocos_dir,
                                static_id,
                                h5_remote,
                                limit,
                                index,
                                flash,
                                unique
                            })

                        }
                    }
                })
            },
            // 获取ppt转码后信息，插入到对应的菜单中
            insertPPT2Menu({static_id,cocos_dir, h5_remote, limit, index, flash, unique}){
                const temp = {
                    type: 'html',
                    theme: {background: {url: '', type: 'image'}},
                    config: {
                        url: '',
                        cocosGameBackgroundImage: ''
                    }
                }
                const newArr = new Array(limit).fill('')
                const arr = newArr.map((v, i) => {
                    let obj = getRandomByObj(this.$_.cloneDeepWith(temp))
                    let name = `Slide${i + 1}`
                    obj.config.cocos_dir = cocos_dir
                    obj.config.static_id = static_id
                    obj.config.url = `${h5_remote}/${name}.html`
                    obj.config.cocosGameBackgroundImage = `${h5_remote}/data/Thumbnails/${name}.png`
                    this.menusDataIds[obj.unique] = this.$_.cloneDeepWith(obj)
                    // delete obj.config
                    return obj
                })

                this.$store.state.pptUnZipConfig = arr
                console.log('6969==>1', unique, arr)
                console.log('6969==>2', cocos_dir)
                this.$toCocosMessage({
                    type: 'SaveConfig',
                    value: {flag: {type: 'ppt', index, flash, unique}}
                })
            },
            realAdd({index, flash}){
                console.log('添加1', index, flash)
                const node = this.menusDataIds[this.menusData.blocksSelected]
                console.log('添加2', node)

                let children = node['children'] || []
                const toUnique = (node.children && node.children[index] && node.children[index].unique) || ''


                let theme = null
                if(node && node.theme) theme = node.theme
                
                let date=new Date();
                let datetime=date.getFullYear()+""+date.getMonth()+""+date.getDate()+""+date.getHours()+""+date.getMinutes()+""+date.getSeconds();
                let unique = "les_"+datetime+"_"+Math.floor(Math.random()*999999);
                let obj = {type: 'animeEditModel', theme:{background:{url:theme, type: 'image'}},thumbnail :'', unique: unique}

                if(children && children.length === 0){
                    children = [obj]
                } else {
                    children.splice(index + 1, 0, obj)//加入第二个
                }
                //
                this.lessonForm = children
                node['children'] = children

                const newChildren = children.map(v=>{
                    let obj = {...v}
                    delete obj.config
                    return obj
                })

                // 刷新当前菜单children
                const curNode = this.$utils.curSelectedNode({})
                curNode.children = newChildren

                // let value = obj
                //
                //
                // // TODO 临时处理新增bug
                // let blocksSelected = this.$store.state.menusData.blocksSelected
                // let lessonSelected = obj.unique
                // let fn1 = setInterval(()=>{
                //     if(this.$store.state.menusData.blocksSelected === blocksSelected &&
                //         `${this.$store.state.menusData.lessonSelected}` === ``){
                //         this.$store.state.menusData.lessonSelected = lessonSelected
                //         this.$store.state.menusData.lessonSelectedConfig = {type: obj.type}
                //         clearInterval(fn)
                //     }
                // }, 500)
                // let fn12 = setTimeout(()=>{
                //     clearTimeout(fn1)
                //     clearInterval(fn12)
                // }, 60000)
                console.log('优化速度realAdd==>GetLessonConfig')
                //
                this.menusDataIds[obj.unique] = obj
                console.log('retro=>向cocos发配置6')
                this.$store.dispatch('setIsBuilding', true)
                this.$toCocosMessage({type: 'GetLessonConfig', value: obj})

                // 如果flash存在则刷新下当前菜单第一个
                if(flash){
                    this.$emit('flashContent')
                }

                this.$nextTick(()=>{
                    console.log('retro lessonSelected10')
                    this.$store.state.menusData.lessonSelected = obj.unique
                    this.$store.state.menusData.lessonSelectedConfig = {type: obj.type}
                    this.autoScrollNext({value: obj})
                })

                // 通知服务端
                const operation = [{node: 'children', toUnique,data:obj,leafUnique:node.unique, operation: 'add'}]
                $eventBus.$emit('__save__',true,null, operation)

                this.$refs.lesson.flashLesson()

            },
            // 导入ppt 后转成菜单数据
            realImportPPT({index, flash, unique}){
                console.log('realImportPPT==>', index, flash, unique)
                const obj = {}
                if(unique) obj['unique'] = unique
                let node = this.menusDataIds[obj.unique]
                if(!unique) node = this.$utils.curSelectedNode(obj)
                console.log('realImportPPT==>', {index, flash, unique}, node)

                // TODO 导入ppt 追加ppt数据
                let toUnique =  ''
                try {
                    const unique = node?.children[index]?.unique
                    if(unique) toUnique = unique
                }catch (e) {
                    console.log('当前没有toUnique==>', e)
                }

                if(!node.children || (node.children && node.children.length === 0)){
                    node.children = this.$store.state.pptUnZipConfig

                    const value =  node.children[node.children.length - 1]
                    console.log('retro lessonSelected11',node)
                    this.$store.state.menusData.lessonSelected = value.unique
                    console.log('优化速度realImportPPT==>GetLessonConfig')
                    console.log('retro=>向cocos发配置7')
                    this.$store.dispatch('setIsBuilding', true)
                    this.$toCocosMessage({type: 'GetLessonConfig', value: this.menusDataIds[value.unique]})
                }else {
                    const newArr = this.$utils.mergeA2B({arrayA:this.$store.state.pptUnZipConfig, arrayB: node.children, indexB: index+1})
                    node.children = newArr
                }

                if(!unique) this.menusDataIds[node.unique] = node

                $eventBus.$emit('onCurForm', node.children)


                this.$refs.lesson.flashLesson()

                // 0.5秒后通知服务端
                const fn = setTimeout(()=>{
                    const operation = [
                        {node: 'children',toUnique, leafUnique: node.unique,data:this.$store.state.pptUnZipConfig,operation: 'addBatch'}
                    ]
                    console.log('操作==>导入ppt', operation, node)
                    $eventBus.$emit('__save__',true,null, operation)

                    // 刷新当前菜单children
                    const newChildren = node.children.map(v=>{
                        let obj = {...v}
                        delete obj.config
                        return obj
                    })
                    const curNode = this.$utils.curSelectedNode({})
                    curNode.children = newChildren

                    clearTimeout(fn)
                }, 500)

                // 刷新下菜单列表
                // this.init()

                // 插入完保存一次
                // this.$emit('save', true)

                // 如果flash存在则刷新下当前菜单第一个
                if(flash){
                    this.$emit('flashContent')
                }
            },
            // 自动判断是否新增滚动
            autoScrollNext({value}){
                // 如果当前选中课件出出框，滚动到选中课件可见
                try {
                    const divBox = document.querySelector('.lesson-box.deep-black .drop-box')
                    const avaHeight = divBox.clientHeight
                    const scroll = divBox.scrollTop
                    const item = document.querySelector('.lesson-box.deep-black .drop-box .lesson')
                    const itemHeight = item.clientHeight
                    const node = this.$utils.curSelectedNode({})
                    const chidren = node.children
                    let index = 0
                    const unique = value.unique || this.$store.state.menusData.lessonSelected
                    chidren.forEach((v, i)=>{
                        if(`${v.unique}`=== `${unique}`){
                            index = i
                        }
                    })
                    console.log('autoScrollNext==>1', divBox)
                    console.log('autoScrollNext==>2', avaHeight)
                    console.log('autoScrollNext==>3', scroll)
                    console.log('autoScrollNext==>4', index)
                    console.log('autoScrollNext==>5', itemHeight)
                    if((avaHeight+scroll)<((index+1)*itemHeight)){
                        this.$nextTick(()=>{
                            const fn = setTimeout(()=>{
                                divBox.scrollTop = ((index+1)*itemHeight) - avaHeight + 14
                                clearTimeout(fn)
                            }, 200)
                        })
                    }
                } catch (e) {
                    console.log('滚动到最后菜单失败==>', e)
                }
            },
            // 选中课程
            onSelect(){
                //console.log('优化速度==>选中课程正在保存', new Date().getTime())
                // 如果当前是游戏情况下，且什么都没变，则直接切课件
                //console.log('优化速度==>onSelect', this.editGameConfig)
                // 优化 如果是从游戏开始切课件 判断当前是否为未保存
                if(this.editGameConfig &&
                    this.editGameConfig.configStatus &&
                    this.editGameConfig.configStatus.saved){
                    const lessonUnique = this.$store.state.menusData.willGo
                    const leesonConfig = this.$store.state.menusData.willGoConfig
                    $eventBus.$emit('changeMenuItem',{lessonUnique, leesonConfig, isDoing: true})
                    return false
                }
                this.$toCocosMessage({type: 'SaveConfig', value: {flag: 'changeMenuItem'}})
            },
            more(item){
                console.log('更多==>', item)
            },
            // 备注
            onRemark(item, index){
                this.$emit('onRemark', item , index)
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=true;
            },
            handleMouseEnterClose(){
                this.$store.state.menusKeyBoard=false;
            }
        }
    }
</script>

<style lang="scss" scoped>
.menus-box{
    display: flex;
    height: 100%;
    flex-direction: row;
    position: relative;
    width: 0px;
    transition: width .2s linear;

    .disabled{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0);
        z-index: 10001;
    }

    .ppt-loading{
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0);
        z-index: 99999;
    }

    &.show{
        width: 350px;
        background-color: white;
        z-index: 1008;
    }

    .txt-box{
        /*width: 350px;*/
        display: flex;
        height: 100%;
        flex-direction: column;
        position: relative;

        &.full{
            overflow: hidden;
        }

        .type-box{
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 14px 0px;
            margin-left: 36px;

            .btn{
                width: 68px;
                height: 28px;
                line-height: 28px;
                background: #36383F;
                font-size: 12px;
                font-weight: 400;
                color: #BDBEC7;
                text-align: center;
                cursor: pointer;

                &.active{
                    font-weight: 500;
                    color: #26282E;
                    background-color: #BDBEC7;
                }

                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }

                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
        }

        .menu-content{
            display: flex;
            flex-direction: row;

            & .isHide{
                width: 0px;
                overflow: hidden;
            }
        }
    }

    .more-boxshadow{
        position: absolute;
        top: 0px;
        right: -38px;
        transform: rotate(180deg);
        height: calc((100vh - 55px)/2 - 72px / 2);
        width: 38px;
        background: url("../../../../assets/images/resource/global/shadow3.png") repeat;
        z-index: 2000;
        transition: all .2s linear;
        pointer-events: none;
    }

    .more-boxshadow2{
        position: absolute;
        top: calc((100vh - 55px)/2 - 72px / 2 + 72px) ;
        right: -38px;
        transform: rotate(180deg);
        height: calc((100vh - 55px)/2 - 72px / 2 + 10px);
        width: 38px;
        background: url("../../../../assets/images/resource/global/shadow3.png") repeat;
        z-index: 2000;
        transition: all .2s linear;
        pointer-events: none;
    }

    .sousuo{
        position: absolute;
        right: -3px;
        top: calc(50vh - 60px);
        z-index: 1000;

        .more{
            position: absolute;
            top: 26px;
            left: -4px;
            width: 18px;
            height: 90px;
            transform: rotate(180deg);
            background: url("../../../../assets/images/resource/global/yousousuo.svg") no-repeat;
        }

        .iconfont {
            display: inline-block;
            font-size: 53px;
            color: white;
            left: 0px;
            top: -47px;
            position: relative;
            cursor: pointer;
            position: relative;

            .icon-jiantouxiangyou{
                position: absolute;
                left: 6px;
                top: 40px;
                color: white;
                font-size: 12px;
                /*transform: rotateZ(180deg);*/
            }
        }
        .img{
            cursor: pointer;
            width: 35px;
            height: 61px;
        }
        &.hide{
            right: -67px;
            transform: rotate(180deg);
            .more{
                left: -68px;
                top: 21px;
            }

            .iconfont{
                top: 30px;
                transform: rotateZ(180deg);
            }
            .icon-jiantouxiangyou{
                left: 4px;
                transform: rotateZ(180deg);
            }
        }
    }
    .menu-btns{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -65px;
        top: 50%;
        margin-top: -72px;
        z-index: 1007;

        .btn{
            margin-top: 18px;
            width: 65px;
            line-height: 14px;
            margin-left: 0px;
        }
        .btn:focus,.btn:hover{
            background: #eee !important;
            border: 1px solid #DCDFE6 !important;
            color: #606266 !important;
        }
        .btn:active{
            border: 1px solid #606266 !important;
        }
        .btn.submit:focus,.btn.submit:hover{
            background: rgba(231, 98, 46, 0.9) !important;
            border-color: rgba(231, 98, 46, 0.9) !important;
        }
        .btn.submit{
            color: white !important;
            border-color: #e7622e !important;
            background-color: #e7622e !important;
        }
        .btn.submit:active{
            border: 1px solid #ff7802 !important;
        }
    }

    &.deep-black{
        &.show {
            width: 230px;
            background-color: #26282E;
            .txt-box {
                .nav-names {
                    display: block;
                }
            }
        }
        .txt-box{
            .nav-names{
                display: none;
                text-align: center;

                .name{
                    font-size: 12px;
                    font-weight: 400;
                    color: #BDBEC7;
                    height: 17px;
                    min-width: 10px;
                    padding: 0px 20px;

                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
}
</style>
